var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.148,
    height: 40.148,
    viewBox: "0 0 40.148 40.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,12.153H13.538V8.692a.692.692,0,0,0-1.384,0v3.461H8.692a.692.692,0,0,0,0,1.384h3.461V17a.692.692,0,1,0,1.384,0V13.538H17a.692.692,0,0,0,0-1.384Z",
    transform: "translate(-2.462 -2.462)",
    fill: "#f90000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45,14H36.692a.692.692,0,0,0,0,1.384H45A.692.692,0,0,0,45,14Z",
    transform: "translate(-11.081 -4.309)",
    fill: "#f90000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.766,0H0V40.148H40.148V0ZM1.384,1.384h18v18h-18Zm0,37.379v-18h18v18Zm37.379,0h-18v-18h18Zm-18-19.382v-18h18v18Z",
    fill: "#f90000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.692,46.384H45A.692.692,0,0,0,45,45H36.692a.692.692,0,0,0,0,1.384Z",
    transform: "translate(-11.081 -13.851)",
    fill: "#f90000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.692,40.384H45A.692.692,0,0,0,45,39H36.692a.692.692,0,0,0,0,1.384Z",
    transform: "translate(-11.081 -12.004)",
    fill: "#f90000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1,37.2a.691.691,0,0,0-.979,0l-2.972,2.972L10.182,37.2a.692.692,0,1,0-.979.979l2.972,2.972L9.2,44.125a.692.692,0,1,0,.979.979l2.972-2.972L16.125,45.1a.692.692,0,1,0,.979-.979l-2.972-2.972L17.1,38.182A.691.691,0,0,0,17.1,37.2Z",
    transform: "translate(-2.77 -11.388)",
    fill: "#f90000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.67cb3b672507057bcb6433c9732690f3.svg";
export { ForwardRef as ReactComponent };